'use client';

import { configKeepData5Mins } from '@/config/useQuery';
import { DepartmentResponse } from '@/server/api/v1/department/department.routes';
import {
    FilterBuilders,
    LogicalOperator,
    OperatorType,
} from '@/server/base/base-trpc-service';
import { api } from '@/trpc/client';
import { DepartmentType } from '@/types/enum';
import CustomSelect, { ComboboxOption, ComboboxProps } from '.';

export type CustomSelectUnitProps<T extends {}> = {
    placeholder?: string;
    t?: any;

    // toàn bộ filter
    overrideFilter?: FilterBuilders<T>[];
    //trường cần map vào value nếu có
    optionValueKey?: keyof DepartmentResponse;
    //trường cần map vào label nếu có
    optionLabelKey?: keyof DepartmentResponse;

    countMaxTo?: number;
    limit?: number;
    countTotal?: boolean;
};

type ExtendProps = ComboboxProps<DepartmentResponse>;

const CustomSelectUnit = (props: CustomSelectUnitProps<any> & ExtendProps) => {
    const {
        placeholder,
        optionValueKey = 'ID',
        optionLabelKey = 'Name',
        countMaxTo = 20,
        limit = 10,
        countTotal = true,
        //TODO:
        overrideFilter,
        ...rest
    } = props;

    const {
        data: apiUnit,
        isLoading,
        isFetching,
    } = api.department.Search.useQuery(
        {
            countMaxTo: countMaxTo,
            limit: limit,
            countTotal: countTotal,
            filters: [
                {
                    key: 'Type',
                    values: [DepartmentType.Unit],
                    logicalOperator: LogicalOperator.Or,
                    operatorType: OperatorType.Equal,
                },
                ...(overrideFilter ?? []),
            ],
        },
        {
            ...configKeepData5Mins,
        }
    );

    let options: ComboboxOption<DepartmentResponse>[] = [];
    if (apiUnit?.data?.Total && apiUnit?.data?.Total > 0) {
        options = apiUnit.data.Items.map((x) => ({
            value: x[optionValueKey as keyof DepartmentResponse] as any,
            label: x[optionLabelKey as keyof DepartmentResponse] as any,
            _origin: x,
        }));
    }

    return (
        <CustomSelect.Single
            itemForceMount={false}
            isSearching={isLoading || isFetching}
            placeholder={placeholder}
            options={options}
            {...rest}
        />
    );
};

export default CustomSelectUnit;
